import { render, staticRenderFns } from "./product_add.vue?vue&type=template&id=29900392&"
import script from "./product_add.vue?vue&type=script&lang=ts&"
export * from "./product_add.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports